/**
 * Copyright (c) 2024 Epinics (PVT) LTD
 * All Rights Reserved.
 * <p>
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * <p>
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * <p>
 */
export const SAMPLE_TYPE = "SAMPLE_TYPE";
export const SET_STEP_ONE_DETAILS = "SET_STEP_ONE_DETAILS";
export const SET_STEP_TWO_DETAILS = "SET_STEP_TWO_DETAILS";
export const SUBMIT_SUCCESSFUL = "SUBMIT_SUCCESSFUL";
export const SUBMIT_FAILED = "SUBMIT_FAILED";
export const SET_IS_LOADING_TRUE = "SET_IS_LOADING_TRUE";
export const SET_IS_LOADING_FALSE = "SET_IS_LOADING_FALSE";
export const CLEAR_ALL_DETAILS = "CLEAR_ALL_DETAILS";
